<template>
<div class="tokendirectEntry">
    <vx-card class="cHeight">
        <div class="vx-row" style="margin-top:20px;">
            <div class="vx-col w-full md:w-1/2" style="margin-left:40px;">
                <div class="vx-row mb-6 ">
                    <div class="vx-col sm:w-1/3 w-full">
                        <!-- <span style="font-weight:600">Doctor Name</span> -->
                        <p style="font-size:13.2px;font-weight:600;padding-top:6px;" >Doctor Name</p>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                     <select v-model="doctorname" class=" vs-select--input myselect" style="height:36px;" @change="getSchedules" v-validate="'required'" name="doctorname">
                                <option v-for="(item,index) in doctorList" v-bind:key="index" :value="item.id">{{item.name}}</option>
                      </select>
    
                        <span class="text-danger text-sm" v-show="errors.has('doctorname')">{{ errors.first('doctorname') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-6 ">
                    <div class="vx-col sm:w-1/3 w-full">
                    <span>
                        <p style="font-size:13.2px;font-weight:600;padding-top:6px;" >Available Date</p>                       
                    </span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                     <select v-model="availabledates" class=" vs-select--input myselect" style="height:36px;" @change="onGridReady" v-validate="'required'" name="availabledates">
                                <option v-for="(item,index) in availabledate" v-bind:key="index" :value="item.id">{{item.name}}</option>
                      </select>
                        <span class="text-danger text-sm" v-show="errors.has('availabledates')">{{ errors.first('availabledates') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-6 ">
    <div class="vx-col sm:w-1/3 w-full">
        <p style="font-size:13.2px;font-weight:600;padding-top:6px;">Patient Name</p>
    </div>
    <div class="vx-col sm:w-2/3 w-full">
        <vs-input 
            class="w-full" 
            v-model="patientName" 
            name="patientName"
            v-validate="'alpha_spaces|min:2'" 
        />
        <span class="text-danger text-sm" v-show="errors.has('patientName')">
            {{ errors.first('patientName') }}
        </span>
    </div>
</div>
<div class="vx-row mb-6 ">
    <div class="vx-col sm:w-1/3 w-full">
        <p style="font-size:13.2px;font-weight:600;padding-top:6px;">Age</p>
    </div>
    <div class="vx-col sm:w-2/3 w-full">
        <vs-input 
            class="w-full" 
            v-model="age" 
            name="age"
            v-validate="'numeric|min_value:0|max_value:120'" 
        />
        <span class="text-danger text-sm" v-show="errors.has('age')">
            {{ errors.first('age') }}
        </span>
    </div>
</div>

                <div class="vx-row mb-6 ">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>
                        <p style="font-size:13.2px;font-weight:600;padding-top:6px;" >Phone Number</p>
                        </span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" v-validate="'required|numeric|min:10|max:11'" name="phoneNo" v-model="phoneNo" />
                        <span class="text-danger text-sm" v-show="errors.has('phoneNo')">{{ errors.first('phoneNo') }}</span>
                    </div>
                </div>

<div class="vx-row" style="width:570px; min-height:180px;">
                <div v-if="show" class="vx-row">
                    <vs-col class="vx-col w-full md:w-1/3" v-for="(display,displayindex) in displayArray" v-bind:key="displayindex">
                        <div class=" text-center example ex1">
                            <label class="radio red" @click="showSlot(display)">
                                <input type="radio" name="group1" :value="display.shiftid" v-model="shiftid" />
                                <span>
                                    <h5>{{display.shift}}</h5>
                                    <p>Available Token:{{display.No}}</p>
                                    <p>Start Time:{{display.time}}</p>
                                </span>
                            </label>
                        </div>
                    </vs-col>
                </div>

                <div v-if="seen" class="vx-row">
                    <vs-col class="vx-col w-full md:w-1/3">
                        <div class=" text-center example ex2">
                            <label class="radio blue">
                                <input type="radio" name="group2" v-model="shiftid" />
                                <span>
                                    <h5>{{shiftname}}</h5>
                                    <p>Available Token:{{tokenNo}}</p>
                                    <p>Start Time:{{time}}</p>
                                </span>
                            </label>
                        </div>
                    </vs-col>
                </div>
</div>
                <div class="vx-row" style="float:right;margin-right:7.5%;margin-top:25px;">
            <vs-button color="primary" type="border" @click="bookToken()">BookToken</vs-button>
        </div>
            </div>
            <!-- 2nd col -->

            <div class="vx-row" style="margin-left:8%;">

                <div class="vx-col w-full ">
                    <div class="tokenbox">

                        <table style="width:340px;">

                            <thead>
                                <th>Time</th>
                                <th>TokenNo</th>
                                <th>Status</th>
                            </thead>
                            <tbody>
                                <tr v-for="(times, index) in slotDetails" v-bind:key="index" :class="{ disabledRow: times.bookingFlag === 'Y' }"
    @click="times.bookingFlag === 'N' && displayToken(
      times.timeSlotId,
      times.tokenTime,
      times.availableTokenNo,
      times.shiftName,
      times.shiftId
    )">
                                    <td><span>{{times.tokenTime}}</span></td>
                                    <td><span>{{times.availableTokenNo}}</span></td>
                                    <td v-if="times.bookingFlag =='Y'" class="booked">Booked</td>
                                    <td v-if="times.bookingFlag =='N'" class="available">Available</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>

            <!-- 2nd col -->
        </div>
        
    </vx-card>
</div>
</template>

<script>
export default {
    name: "tokendirectEntry",
    data() {
        return {
            activeConfirm: false,
            show: false,
            seen: false,
            time: "",
            No: "",
            shift: "",
            slotId: null,
            
            listArray: [],
            list: [],
            doctorname:0,
            availabledates: null,
            phoneNo: "",
            shiftid: null,
            patientName: "",
            age: null,
            doctorList:[{id:0,name:"Select"}],
            availabledate: [{
                "id": null,
                "name": "Select"
            }],
            slotDetails: [],
            displayArray: [{}]

        }
    },
    mounted() {
        this.getDoctor();
    },
    methods: {

        onGridReady(params) {
            var listData = [];
            var shiftname;
            var request = {
                companyId: this.$session.get('companyId'),
                doctorId: this.doctorname,
                availableDate: this.availabledates
            };
            this.$http.post(
                    "getalldoctorschedules",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                    var result = response.data.data;
                    var tokenArray = {};
                    this.displayArray = [];

                    result.forEach((value, key) => {
                        var displayData = {};
                        value.tokenDetails.forEach((item, index) => {
                            if (item.bookingFlag == 'N' && Object.keys(displayData).length === 0) {
                                displayData = {
                                    "time": item.tokenTime,
                                    "No": item.availableTokenNo,
                                    "shift": value.shiftName,
                                    "slotId": item.timeSlotId,
                                    "shiftid": value.shiftId,

                                }
                                this.show = true;
                                this.seen = false;
                                this.displayArray.push(displayData);

                            }
                            item.shiftName = value.shiftName;
                            item.shiftId = value.shiftId
                            listData.push(item);

                        });
                    })

                    this.slotDetails = listData;
                    console.log("shift data",this.slotDetails)

                })

        },
        getDoctor: function () {
            var request = {
                companyId: this.$session.get('companyId')
            };
            this.$http.post(
                    "getdoctorlist",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                    response.data.data.forEach((value) => {
                        this.doctorList.push(value);
                    })
                });
        },
        getSchedules: function () {
         this.slotDetails = [];   
        this.seen = false;      
        this.show = false;  
            this.availabledate = [{
                id: null,
                name: "Select"
            }];
            this.availabledates = null;
            this.show = false;
            var request = {
                companyId: this.$session.get('companyId'),
                doctorId: this.doctorname
            };
            this.$http.post(
                    "getdoctorshedules",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                    var dates = {}
                    response.data.data.forEach((value) => {
                        dates = {
                            id: value,
                            name: value
                        }
                        this.availabledate.push(dates);
                    });
                       if (response.data.data.length > 0) {
    
      this.availabledates = response.data.data[0];

     
      this.onGridReady();
    }
     else {

            
            this.slotDetails = [];
            this.seen = false;
            this.show = false;

        }

                });
        },
        displayToken(timeSlotId, tokenTime, availableTokenNo, shiftName, shiftId) {
            this.seen = true;
            this.show = false;
            this.slotId = timeSlotId;
            this.shiftid = shiftId;
            this.shiftname = shiftName;
            this.tokenNo = availableTokenNo;
            this.time = tokenTime;
            console.log("dispaly token details",this.slotId,this.shiftid)

        },
        bookToken: function () {

            this.$validator.validateAll().then(result => {
                if (result) {
                    this.openConfirm();
                } else {
                    this.errors.any();
                }
            })

        },
        showSlot(timeSlot) {
            this.slotId = timeSlot.slotId;
              this.shiftid = timeSlot.shiftid;
        },
        openConfirm() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: `Please Confirm`,
                text: 'Do you want to Book Appointment',
                accept: this.acceptAlert
            })
        },
        clearForm(){
            this.doctorname="Select";
            this.availabledates="Select";
            this.phoneNo="";
            this.show=false;
            this.seen=false;
            this.slotDetails="";
            this.patientName = "";   
            this.age = null;   
        },
        acceptAlert() {
            var request = {
                companyId: this.$session.get('companyId'),
                timeSlotId: this.slotId,
                patientPhoneNo: this.phoneNo,
                doctorId: this.doctorname,
                availableDate: this.availabledates,
                shiftId: this.shiftid,
                patientName: this.patientName || null,
                patientAge: this.age || null
            };

            this.$http.post(
                    "booknewtoken",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json",
                            //"AUTH_KEY": this.$session.get("userToken"),   
                            //"USER_ID": this.$session.get("userId"),       
                            //"COMPANY_ID": this.$session.get("companyId") 
                        }
                    }
                )
                .then(response => {

                    var No = response.data.data.tokenNo
                    this.$vs.notify({
                        title: 'Your Token Number is ' + No,
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        position: 'top-center',
                    })
                    this.clearForm();
                }).catch(error => {
                    this.$vs.notify({
                        title: 'Error Occured While Saving',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        position: 'top-center'
                    })

                });
        },
    }

}
</script>

<style scoped>
.cardStyle {
    background-color: #87ceeb33;
    border: 1px solid hsl(194, 59%, 80%);
    margin-top: 54px;
    width: 165px;
}

.tokenbox {
    width: 100%;
    margin-top: 6px;
    height: 420px;
    overflow-y: scroll;
    border: 1px solid #dae1e787;
}

td,
th {
    text-align: center;
}

table {

    border-collapse: collapse;
}

table th {
    text-align: center;

}

table tr:hover {
    background-color: #e2e8e2;
    cursor: pointer;
}

table tr {
    line-height: 2.5rem;
    border-bottom: 1px solid #e2e8e2;

}

table thead {
    background: #eaeff3;
}

.cHeight {
    min-height: 550px;
}

.booked {
    color: #ff0000b3;
}

.available {
    color: #008000ad;
}

.example {
    margin: 20px;
}

.example input {
    display: none;
}

.example label {
    margin-right: 20px;
    display: inline-block;
    cursor: pointer;
    width: 165px;
}

.ex1 span {
    display: block;
    padding: 10px 10px 10px 10px;
    border: 2px solid #ddd;
    border-radius: 5px;
    position: relative;
    transition: all 0.25s linear;
}

.ex1 span h5 {
    padding-bottom: 5px;
}

.ex1 span:before {

    position: absolute;
    left: 5px;
    top: 50%;
    -webkit-transform: translatey(-50%);
    transform: translatey(-50%);
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #ddd;
    transition: all 0.25s linear;
}

.ex1 input:checked+span {
    background-color: #fff;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
}

.ex1 .red input:checked+span {
    color: blue;
    border-color: #00ffd291;
}

.ex1 .red input:checked+span:before {
    background-color: blue;
}

.ex2 span {
    display: block;
    padding: 10px 10px 10px 10px;
    border: 2px solid #ddd;
    border-radius: 5px;
    position: relative;
    transition: all 0.25s linear;
}

.ex2 span h5 {
    padding-bottom: 5px;
}

.ex2 span:before {

    position: absolute;
    left: 5px;
    top: 50%;
    -webkit-transform: translatey(-50%);
    transform: translatey(-50%);
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #ddd;
    transition: all 0.25s linear;
}

.ex2 input+span {
    background-color: #fff;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
}

.ex2 .blue input+span {
    color: blue;
    border-color: #00ffd291;
}

.ex2 .blue input+span:before {
    background-color: blue;
}
.disabledRow {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}

</style>
